import { dispatcher, api, RESOURCE_CREATE } from 'react-structure-admin';

export const EVENT = 'EVENT';

export const EVENT_FETCH_APPOINTMENT_TODAY = 'EVENT_FETCH_APPOINTMENT_TODAY';
export const EVENT_FETCH_APPOINTMENT_TODAY_FINISHED =
  'EVENT_FETCH_APPOINTMENT_TODAY_FINISHED';

export const RESOURCE_FETCH = 'RESOURCE_FETCH';
export const RESOURCE_FETCH_FINISHED = 'RESOURCE_FETCH_FINISHED';

export const EVENT_CHANGE_STATUS = 'EVENT_CHANGE_STATUS';
export const EVENT_CHANGE_STATUS_FINISHED = 'EVENT_CHANGE_STATUS_FINISHED';

export const EVENT_DELETE = 'EVENT_DELETE';
export const EVENT_DELETE_FINISHED = 'EVENT_DELETE_FINISHED';

export const EVENT_GET_VIEW = 'EVENT_GET_VIEW';
export const EVENT_GET_VIEW_FINISHED = 'EVENT_GET_VIEW_FINISHED';

export const EVENT_GET_VIEW_CLOSE = 'EVENT_GET_VIEW_CLOSE';

export const EVENT_REFRESH = 'EVENT_REFRESH';

export const EVENT_SCHEDULES_UNLOAD = 'EVENT_SCHEDULES_UNLOAD';
export const EVENT_SCHEDULES = 'EVENT_SCHEDULES';
export const EVENT_SCHEDULES_FINISHED = 'EVENT_SCHEDULES_FINISHED';

export const EVENT_FETCH_FAST_SEARCH = 'EVENT_FETCH_FAST_SEARCH';
export const EVENT_FETCH_FAST_SEARCH_FINISHED =
  'EVENT_FETCH_FAST_SEARCH_FINISHED';

export const fetch = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'events',
    actionType: RESOURCE_FETCH,
    effect: async () => api.fetch('events', params)
  });
};

export const fetchFastSearch = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'events',
    actionType: EVENT_FETCH_FAST_SEARCH,
    payload: params,
    effect: async () => api.fetch('events/fast-search', params)
  });
};

export const fetchAppointmentToday = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'events',
    actionType: EVENT_FETCH_APPOINTMENT_TODAY,
    effect: async () => api.fetch('events', params)
  });
};

export const fetchByPatient = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'events',
    actionType: EVENT_SCHEDULES,
    effect: async () => api.fetch('events', params)
  });
};

export const fetchByPatientUnload = () => (dispatch) => {
  dispatch(dispatcher.createAction(EVENT_SCHEDULES_UNLOAD, 'events'));
};

export const changeStatus = (id, status, onFail) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'events',
    payload: status,
    actionType: EVENT_CHANGE_STATUS,
    effect: async () => api.put(`events/${id}/change-status`, { status })
  });
};

export const remove = (id) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'events',
    actionType: EVENT_DELETE,
    payload: id,
    effect: async () => api.del('events', id)
  });
};

export const removeWithRecurring = (id) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'events',
    actionType: EVENT_DELETE,
    payload: id,
    effect: async () => api.del('events', `${id}/with-recurring`)
  });
};

export const refresh = () => (dispatch) => {
  dispatch(dispatcher.createAction(EVENT_REFRESH, 'events'));
};

export const getView = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'events',
    actionType: EVENT_GET_VIEW,
    effect: async () => api.get('events', id),
    onSuccess
  });
};

export const getViewClose = () => (dispatch) => {
  dispatch(dispatcher.createAction(EVENT_GET_VIEW_CLOSE, 'events'));
};

export const createPatient = (id, data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: RESOURCE_CREATE,
    effect: async () => api.post(`events/${id}/patient`, data),
    payload: data,
    onSuccess
  });
};

export const updatePatient = (id, data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: RESOURCE_CREATE,
    effect: async () => api.put(`events/${id}/patient`, data),
    payload: data,
    onSuccess
  });
};
